import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RulesAndRegulationComponent } from './rules-and-regulation/rules-and-regulation.component';
import { AuthGuard } from '../../services/auth-guard.service';

const routes: Routes = [
  {path:'rulesAndRegulation',
   component:RulesAndRegulationComponent,
   canActivate:[AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RulesAndRegulationRouting { }
